import React from 'react';
import { useTheme } from 'styled-components';

import { IconProps } from './types';

/** @deprecated Use icons from '@sighten/beacon/icons' instead */
export function PlayIcon({ color: colorProp }: IconProps) {
  const theme = useTheme();
  const color = colorProp || theme.colors.chartChartBlueSecondary2100;

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3633_10664)">
        <path
          d="M2.71398 14.2625L12.9979 7.97787L2.71398 1.69327V14.2625ZM1.87485 0.197104C2.41761 -0.106414 3.0782 -0.0921307 3.60668 0.229241L13.8906 6.51384C14.4012 6.8245 14.7119 7.37798 14.7119 7.97787C14.7119 8.57776 14.4012 9.12767 13.8906 9.4419L3.60668 15.7265C3.0782 16.0514 2.41404 16.0622 1.87485 15.7586C1.33565 15.4551 1 14.8838 1 14.2625V1.69327C1 1.07195 1.33565 0.500622 1.87485 0.197104Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_3633_10664">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default PlayIcon;
